import { Chip } from 'common/design-system/components-v2';
import { LicensesTransformer } from './Licenses.types';

export const transformToChips: LicensesTransformer = ({ value }) => (
    <Chip disableInteraction key={`package-license-${value}`} label={value} />
);
export const transformToValue: LicensesTransformer = ({ value }) => value;
